import React, { Component } from "react";

import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from "@coreui/react";
import { createPortal } from "react-dom";

import URL from "../../config/api";

import "./style.css";

const avatars = [
  "avatars/1.png",
  "avatars/2.png",
  "avatars/3.png",
  "avatars/4.png",
  "avatars/5.png",
  "avatars/6.png",
  "avatars/7.png",
  "avatars/8.png"
];

const appRoot = document.getElementById("root");

class AvatarsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: Math.max(
        0,
        avatars.findIndex(item => item === props.url)
      )
    };

    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return createPortal(
      <CModal
        show={this.props.show}
        onClose={() => this.props.onClose()}
        centered
        size="lg"
      >
        <CModalHeader closeButton>
          <CModalTitle>Avatar</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            {avatars.map((url, index) => (
              <CCol
                key={url}
                className="d-flex align-items-center justify-content-center my-3"
                xs="3"
              >
                <div
                  className={`avatars-modal-circle rounded-circle cursor${
                    this.state.selected === index ? " selected" : ""
                  }`}
                  onClick={() => this.setState({ selected: index })}
                >
                  <img
                    src={URL.img + url}
                    className="rounded-circle"
                    style={{ border: "6px solid transparent" }}
                  />
                </div>
              </CCol>
            ))}
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="mr-2"
            onClick={() => this.props.onAvatar(avatars[this.state.selected])}
          >
            Salvar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

export default AvatarsModal;
